import { render, staticRenderFns } from "./SocioForm.vue?vue&type=template&id=5ecb23cb&"
import script from "./SocioForm.vue?vue&type=script&lang=js&"
export * from "./SocioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports